module.exports = __webpack_public_path__ + "img/電気回路24_6_4_1.4336fce2.png";